module.exports = __webpack_public_path__ + "static/media/painting3.7ca9d1ee.jpg";